/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class ERCOTSettlementPoint extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "ERCOTSettlementPoint";
}

const servicePlugin = makeServicePlugin({
  Model: ERCOTSettlementPoint,
  service: feathersClient.service("data-services/ercot/settlement-points"),
  idField: "Settlement Point",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
